// Контентный попап в рамках компонента welcome popup
// для роли "не разработчик"

const template = /* html */`
    <div class="flex-column items-start gap-1">
        <h3>Вот что можно сделать без навыков программирования</h3>
        <span>
            Обычно «Дадату» подключают разработчики — по API. 
            Но кое-что можно и без них.
        </span>
        <ol class="flex-column items-start gap-1">
            <li>
                Подключить сервис «Подсказки» к CMS, CRM и конструкторам сайтов 
                с помощью готовых интеграций. Проверьте, 
                есть ли нужная в <a href="/suggestions/#platforms">списке</a>.
            </li>
            <li>
                Загрузить в «Стандартизацию» excel- и CSV-файлы с данными, 
                которые вы уже собрали. Инструкции — <a href="/clean/#process-file">на странице 
                инструмента</a>.
            </li>
            <li>
                Сразу протестировать нужные сервисы. Для этого мы подключили вам 
                подписку по бесплатному тарифу. 
                <a href="/blog/instructions/integration-guide/#pricing">Часть сервисов 
                не входит в подписку</a>, но их тоже тестируют бесплатно — в рамках запросов, 
                которые мы дарим новичкам.
            </li>
            <li v-if="showContacts">
                Подписаться на <a href="https://t.me/+JY6I09ma0f1lZmVi">телеграм-канал 
                «Дадаты» для срочных новостей</a>.
            </li>
        </ol>
        <span v-if="showContacts">
           Если не понимаете, зачем нужна «Дадата», — почитайте, 
           <a href="/blog/cases/">как бизнес использует наши сервисы</a>. 
           Или смело 
           <a :href="'/support/' + userecho">пишите в поддержку</a> — разберемся.
        </span>
    </div>
`;

export default {
    template,
    inject: ["userecho"],
    props: { showContacts: Boolean },
};
